import { useEffect, useState } from "react";
import { createAndSendOtp, verifyOtp } from "../../services/epic/bloodDonation";
import { maskMobileNumber } from "../../common/MaskedMobileNo";

const MobileNumberVerificationPopup = ({
  setRequestStep,
  setMobileNumberVerificationPupup,
  mobileNum,
  fetchUpcomingDonationDetailsByMobileNo,
  setIsLoading,
  id,
  translationMap
}) => {
  const [otpError, setOtpError] = useState("");
  const [alert, setAlert] = useState(false);
  const [error, setError] = useState(false);

  const [otp, setOtp] = useState({
    first: "",
    second: "",
    third: "",
    fourth: ""
  });
  const [timer, setTimer] = useState(300);
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const [isContinueDisabled, setIsContinueDisabled] = useState(true);
  const [isBlocked, setIsBlocked] = useState(false);
  const [blockTimer, setBlockTimer] = useState(0);
  const [, setOtpEntered] = useState(0);

  useEffect(() => {
    setIsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (blockTimer > 0) {
      const interval = setInterval(() => {
        setBlockTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else if (blockTimer === 0 && isBlocked) {
      setIsBlocked(false);
    }
  }, [blockTimer, isBlocked]);

  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(countdown);
    } else {
      setIsResendEnabled(true);
    }
  }, [timer]);

  const handleOtpChange = (e) => {
    setError(false);
    setOtpError("");
    const { id, value } = e.target;
    if (/^\d?$/.test(value)) {
      setOtp((prevOtp) => {
        const updatedOtp = { ...prevOtp, [id.split("-")[1]]: value };
        const allInputsCleared = Object.values(updatedOtp).every(
          (val) => val === ""
        );
        setIsContinueDisabled(allInputsCleared);
        return updatedOtp;
      });
      // Automatically move to the next input field
      if (value.length === 1 && e.target.nextElementSibling) {
        e.target.nextElementSibling.focus();
      }
    }
  };

  const handleResendCode = async () => {
    setError(false);
    setOtpError("");
    if (isBlocked) {
      setError(true);
      setOtpError(
        translationMap?.otpBlocked
      );
      return;
    }
    const info = await createAndSendOtp(mobileNum);
    //console.log("handling resend otp", info);
    if (info) {
      setAlert(true);
      setIsResendEnabled(false);
      setTimer(300);
    }
  };

  const otpVerification = async () => {
    setAlert(false);
    setOtpError("");
    setError(false);
    const fullOtp = otp.first + otp.second + otp.third + otp.fourth;
    try {
      const result = await verifyOtp(fullOtp, id);
      setOtp({ first: "", second: "", third: "", fourth: "" });
      if (result?.data?.success) {
        const upcomingDonationsInfo = await fetchUpcomingDonationDetailsByMobileNo(mobileNum);
        if (upcomingDonationsInfo) {
          setRequestStep(12);
          return;
        }
        setError(false);
        setRequestStep(2);
        window.parent.scrollTo(0, 0);
        setMobileNumberVerificationPupup(false);
      }
    } catch (error) {
      setOtp({ first: "", second: "", third: "", fourth: "" });
      if (error.response && error.response.status === 400) {
        if (error.response.data.error === "otpBlocked") {
          setIsBlocked(true);
          setBlockTimer(300);
          setError(true);
          setOtpError(
            translationMap?.otpBlocked || "Your OTP has been blocked due to multiple failed attempts. Please try again after 5 minutes."
          );
        } else if (error.response.data.error === "otpExpired") {
          setError(true);
          setOtpError(translationMap?.otpExpired);
        } else {
          setError(true);
          setOtpError(translationMap?.invalidOtp);
        }
      } else {
        setError(true);
        setOtpError(
          translationMap?.unexpectedError
        );
      }
      setOtpEntered((prevOtp) => prevOtp + 1);
      //console.error("OTP verification error:", error);
    }
  };

  const handleCloseModal = async () => {
    setMobileNumberVerificationPupup(false);
    const fullOtp = otp.first + otp.second + otp.third + otp.fourth;
    await verifyOtp(fullOtp, id);
  };

  return (
    <>
      <div
        className="modal fade Custom_Modal_Box show"
        id="mobilenumberverification"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{ display: "block" }}>
        
        <div className="modal-dialog CoveragePlan_Dialog2" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="Title_Inner_Box">
                <h6 className="MainTitleOne">
                  {" "}
                  {translationMap?.mobileNoVerification}
                </h6>
              </div>
            </div>
            {alert &&
            <div className="Alert_Main_Box">
                <div className="AlertInnerBox GreenAlertInnerBox alert alert-dismissible fade show">
                  <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  onClick={() => setAlert(false)}>
                  
                    &times;
                  </button>
                  <div className="Icon_box">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a>
                      <span className="material-symbols-outlined">
                        check_circle
                      </span>
                    </a>
                  </div>
                  <div className="alert_text">
                    <h6>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a> {translationMap?.otpResendSuccess}</a>
                    </h6>
                  </div>
                </div>
              </div>
            }

            <div className="modal-body">
              <div className="Manage_Dependent_Modal_Box3">
                <p className="para_txt">
                  {translationMap?.pleaseEnterOtp} {" "}
                  <span style={{ direction: "ltr" }}>{maskMobileNumber(mobileNum)}</span>
                </p>
                <div className="opt_main_box">
                  <p>{translationMap?.verificationCode}</p>
                  <div className="custom_row" style={{ direction: "ltr" }}>
                    {["first", "second", "third", "fourth"].map(
                      (digit, index) =>
                      <input
                        key={digit}
                        id={`otp-${digit}`}
                        type="number"
                        inputmode="numeric"
                        min="0"
                        max="9"
                        className={`input_number_verify ${
                        error ? "errorRedAlert" : ""}`
                        }
                        placeholder="0"
                        style={{ MozAppearance: "textfield" }}
                        value={otp[digit]}
                        onChange={handleOtpChange}
                        onKeyDown={(e) => {
                          if (
                          e.key === "Backspace" &&
                          !otp[digit] &&
                          index > 0)
                          {
                            document
                            .querySelectorAll(".input_number_verify")[
                            index - 1].focus();
                          }
                        }} />


                    )}
                  </div>
                  {error &&
                  <div className="verifyContent">
                    <p className="codeErrorAlert">{otpError}</p>
                  </div>
                  }
                  <p className="opt_timer_box">
                    {timer > 0 &&
                    <span className="optTimer">{`(${Math.floor(
                        timer / 60
                      )}:${String(timer % 60).padStart(2, "0")})`}</span>
                    }
                  </p>
                </div>
                <h6 className="Gray_Title">
                  {translationMap?.dintGetCode}
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    onClick={() => {
                      if (isResendEnabled) {
                        handleResendCode();
                      }
                    }}
                    style={{
                      color: isResendEnabled ? "#3b4f63" : "gray",
                      cursor: isResendEnabled ? "pointer" : "not-allowed"
                    }}>
                    
                    {translationMap?.clickToResend}
                  </a>
                </h6>
              </div>
            </div>

            <div className="modal-footer modal_footer_btn_box2">
              <button
                onClick={handleCloseModal}
                type="button"
                className="btn bluetrans_btn_link"
                data-dismiss="modal">
                
                {translationMap?.back}
              </button>
              <button
                onClick={otpVerification}
                type="button"
                data-dismiss="modal"
                className={`${
                isContinueDisabled ? "disabled_btn_link" : "btn blue_btn_link"}`
                }
                disabled={isContinueDisabled}>
                
                {" "}
                {translationMap?.continue}{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>);

};

export default MobileNumberVerificationPopup;